import React, { FC, use } from "react";
import type { GenericRecordTableItem } from "@app/components/shared/Table/Table";
import { PaymentsContext } from "../../../scripts/context/accountingData/PaymentsProvider";
import { useRecordSaldoOrigin } from "@app/columns/components/ColStatus";
import { Utils } from "@binale-tech/shared";

export const ColOffen: FC<{ tableItem: GenericRecordTableItem }> = ({ tableItem }) => {
    const { recordRelation } = use(PaymentsContext);
    // if there is a pointer to the saldo record, we should edit payments there
    const paymentRecord = useRecordSaldoOrigin(tableItem?.item);

    if (!paymentRecord) {
        return "";
    }
    return Utils.CurrencyUtils.currencyFormat(paymentRecord.getOpenBrutto(recordRelation.get(paymentRecord.key)));
};
